// Which kind of user someone is, as the app shows it: the type the server recorded for them, or,
// for an account the server has not recorded yet, the type on their own profile. A recorded value
// that is not one of the three types is no type, and the profile is not consulted in its place.
// The server enforces every type rule on its own; this only decides what the app shows.

export const USER_TYPES = Object.freeze(['candidate', 'customer', 'agency']);

const validType = value => (USER_TYPES.includes(value) ? value : null);

/**
 * @param {Object|null} user a current user or user entity
 * @returns {'candidate'|'customer'|'agency'|null}
 */
export const userTypeOf = user => {
  const profile = user?.attributes?.profile;
  const recorded = profile?.metadata?.userType;
  if (recorded !== undefined && recorded !== null) return validType(recorded);
  return validType(profile?.publicData?.userType);
};
